<template>
  <div>
    <attribute-search-page-component
      v-if="attributeSearchVisible"
      :attributesearchresult="attributeSearchResult"
      :query="query"
      :queryCategory="queryCategory"
    >
    </attribute-search-page-component>
    <product-search-page-component v-show="productSearchVisible">
    </product-search-page-component>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      attributeSearchResult: null,
      attributeSearchVisible: true,
      productSearchVisible: false,
      query: "",
      page: 1,
      searchType: null,
    };
  },
  methods: {
    fetchAttributes: async function () {
      var result = await fetch(
        `/attributesearch?query=${this.query}&cat=${this.queryCategory}&page=${this.page}`
      );
      if(result) {
        try {
          var jsonResult = await result.json();
          if(jsonResult?.items?.length > 0) {
            this.attributeSearchResult = jsonResult;
            // this.showAttributeSearch();
            return;
          }
        }catch(ex) {
          // handled further
        }
      }

        this.hideAttributeSearch();
        this.showProductSearch();
    },
    parseUrl() {
      let queryStringParams = window.location.search;
      let urlParams = new URLSearchParams(queryStringParams);

      this.searchType = urlParams.get("searchtype");
      this.query = urlParams.get("q");
      this.queryCategory = urlParams.get("cat");
      this.page = urlParams.get("pagina");
    },
    showProductSearch: function() {
      this.attributeSearchVisible = false;
      this.productSearchVisible = true;
    },
    hideAttributeSearch: function() {
        this.attributeSearchVisible = true;
        this.productSearchVisible = false;
    }
  },
  mounted() {
    this.parseUrl();
    let queryStringParams = window.location.search;
    let urlParams = new URLSearchParams(queryStringParams);
    this.query = urlParams.get("q");
    this.queryCategory = urlParams.get("cat");
    if(this.searchType == "product") {
        this.showProductSearch();
    }else {
        this.fetchAttributes();
    }
  },
};
</script>